// extracted by mini-css-extract-plugin
export default {"container":"SpreadListView_container__Bnbb3","pageCounter":"SpreadListView_pageCounter__HYPy7","SpreadListView":"SpreadListView_SpreadListView__8uEXE"};